var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomBusiSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "paufss0q8a",
    width: 24,
    height: 15,
    x: 8,
    y: 13,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 13h23.563v14.12H8V13z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#paufss0q8a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M27.326 23.956c0 .365-.295.662-.662.662-.365 0-.662-.297-.662-.662v-7.33c0-.366.297-.662.662-.662.367 0 .662.296.662.662v7.33zm-2.136 0c0 .365-.295.662-.662.662-.365 0-.663-.297-.663-.662v-4.462c0-.366.298-.662.663-.662.367 0 .662.296.662.662v4.462zm-2.137 0c0 .365-.295.662-.662.662-.365 0-.663-.297-.663-.662v-2.868c0-.367.298-.664.663-.664.367 0 .662.297.662.664v2.868zM19.61 21.46c0 .365-.297.662-.663.662-.367 0-.662-.297-.662-.662v-.792l-1.705 1.704c-.258.258-.678.258-.936 0l-.556-.556-1.342 1.343c-.13.13-.3.195-.47.195-.169 0-.338-.065-.468-.195-.258-.258-.258-.678 0-.937l1.812-1.81c.259-.26.678-.26.936 0l.557.555 1.237-1.236h-.793c-.367 0-.662-.297-.662-.662 0-.366.295-.663.662-.663h2.262c.437 0 .791.355.791.79v2.264zM30.691 13H8.873c-.482 0-.873.39-.873.871 0 .483.391.873.873.873h1.973v9.824c0 1.408 1.141 2.55 2.55 2.55H26.65c1.408 0 2.55-1.142 2.55-2.55v-9.824h1.49c.48 0 .872-.39.872-.873 0-.482-.391-.871-.872-.871z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBusiSmall);
export default __webpack_public_path__ + "static/media/room_busi_small.38a05f33bd8976374d8766d50f335aa4.svg";
export { ForwardRef as ReactComponent };